import moment from 'moment';

export const getLag = (date1, date2) => {
    const lag = Math.abs(moment(date1).diff(moment(date2), 'days')) - 1;
    return lag;
};
